export const TOGGLE_MODAL_TRANSACTIONS = 'TOGGLE_MODAL_TRANSACTIONS';

export function toggleModalTransactions(parameterInfo) {
  return {
    type: TOGGLE_MODAL_TRANSACTIONS,
    parameterInfo,
  };
}
